import { useMemo } from 'react';

const useUserCompany = user => {
  const companies = useMemo(() => user?.companyAccess ?? [], [user]);
  return companies[0] ?? null;
};

export default useUserCompany;
